export function createProps(data) {
    let type = String
    const _type = typeof data;
    switch (_type) {
        case 'boolean':
            type = Boolean
            break;
        case 'number':
            type = Number
            break;
        case 'object':
            if (data instanceof Array) {
                type = Array
            } else {
                type = Object
            }
            break;
        default:
            break;
    }
    const _props = {type, default: data}
    if (type === Array || type === Object) {
        _props.default = () => data
    }
    return _props
}